import produce from 'immer';
import create from 'zustand';
import { identity, pickBy } from 'lodash';

// Create request parameters based on search data
const createParameters = (search) => pickBy({
	related: 'report',
	state: search.state,
	'name|surname:likeLower': `%${search.name}%`,
	page: search.page
}, identity);

// Initial search data
const SEARCH_INITIAL = {
	name: '',
	state: 'active',
	page: 1
};

// Initial store value
const GRADE_REPORT_INITIAL = {
	// Search data
	search: SEARCH_INITIAL,

	// Request parameters
	parameters: createParameters(SEARCH_INITIAL),

	// Collected data
	result: {
		students: [],
		total: 0
	}
};

export const useGradeReportStore = create(set => ({
	...GRADE_REPORT_INITIAL,

	// Handle search data change
	onSearch: ({ name, value }) => set(produce(state => {
		state.search[name] = value;
		if (name !== 'page') state.search.page = 1;
		state.parameters = createParameters(state.search);
	})),

	// Handle report change
	onChangeReport: (studentId, { name, value }) => set(produce(state => {
		const student = state.result.students.find(student => student.id === studentId);
		student.report[name] = value;
	})),

	// Handle report update
	onUpdateReport: (report) => set(produce(state => {
		const student = state.result.students.find(student => student.id === report.studentId) ?? {};
		student.report = report;
	})),

	// Handle grade change
	onChangeGrade: (studentId, { name, value }) => set(produce(state => {
		const student = state.result.students.find(student => student.id === studentId);
		student.graderel[name] = value;
	})),

	// Initialize collected data
	onInit: (result) => set(produce(state => {
		state.result.total = result.total ?? 0;
		state.result.students = result.students.map(student => ({
			...student,
			report: student.report ?? {
				warrant: '',
				achievement: '',
				issuedAt: null
			}
		})) ?? [];
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_REPORT_INITIAL
	})
}));